import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export const postFirmwareBackupUseCase = async (body) => {
  try {
    const state = store.getState();

    const namespace = state?.yourSlice?.authContext?.customerNamespace;

    const sourceId = state?.yourSlice?.connectionView?.source?.source_id;

    const response = await apiUseCases.postCreateFirmwareBackup(
      namespace,
      sourceId,
      body,
    );

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    console.error("postFirmwareBackupUseCase error:", error);

    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to create firmware backup")
        .message,
    };
  }
};
